module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"clients":"Клиенты","extension":"Расширение для Google Chrome для HH.ru","FAQ":"Вопрос-ответ","about":"Что говорят о Huntica","press":"В прессе","registration":"Регистрация","slogan":"Huntica — сервис виртуальных собеседований с человеческим лицом","sloganShort":"сервис виртуальных собеседований с человеческим лицом"}}')
  delete Component.options._Ctor
}
